import { triniumApi } from '@api/Trinium/slice';
import { BaseApiRequest } from '@api/Trinium/types';
import { LegRaw } from '@api/Trinium/Endpoints/Leg';
import { upsertLegInDispatchCache } from '@api/Trinium/Endpoints/Dispatch/types';
import { PutStreetTurnRequest, StreetTurn, transformStreetTurnResponse } from './types';

export const streetTurnSlice = triniumApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchStreetTurn: builder.query<
        StreetTurn[],
        BaseApiRequest & {
          legId: number;
        }
      >({
        query: ({ terminalNumber, legId }) => ({
          url: `/${terminalNumber}/streetturn/${String(legId)}`
        }),
        transformResponse: transformStreetTurnResponse
      }),
      putStreetTurn: builder.mutation<LegRaw[], PutStreetTurnRequest>({
        query: ({ terminalNumber, legId, actionType }) => ({
          url: `${terminalNumber}/streetturn/${String(legId)}`,
          method: 'PUT',
          body: {
            action: actionType.action,
            data: actionType.data
          }
        }),
        async onQueryStarted(_params, { queryFulfilled }) {
          const result = await queryFulfilled;
          // Update the cache with the newly retrieved Leg data
          result.data.forEach((leg: LegRaw) => {
            upsertLegInDispatchCache({
              legId: leg.id,
              jobId: leg.jobId,
              puId: leg.puId,
              puName: leg.pu?.name,
              puCity: leg.pu?.city,
              puState: leg.pu?.state,
              hasNotes: true
            });
          });
        }
      })
    };
  }
});

export const { useFetchStreetTurnQuery, usePutStreetTurnMutation } = streetTurnSlice;
